module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "bcheckbox",
    on: {
      "click": _vm.change
    }
  }, [_c('span', {
    staticClass: "bcheckbox-default"
  }, [_c('span', {
    class: _vm.getClass
  })]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-label",
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.label))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e6d70de0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bCheckBox.vue
// module id = 525
// module chunks = 1